export const fr = {
    titreOnglet: "Détail du compte | Desjardins"
};
